<div id="clmois">
  <div class="cal" (mouseenter)="initFunctionSelection()" *ngFor="let cals of listeCal; ">
    <div class="header">
      <span class="month-year" id="label"> {{ cals.showMois }} </span>
    </div>
    <table id="days">
    <td> </td>
      <td>L</td>
      <td>M</td>
      <td>M</td>
      <td>J</td>
      <td>V</td>
      <td>S</td>
      <td>D</td>
    </table>
  <!--
      (mouseenter)="mouseEnterEvent($event,jour)"
      (mousedown)="mousedownEvent($event,jour)"
      (mouseup)="mouseupEvent($event,jour)" 
      (keydown) = "keydownEvent($event)"
      (mouseleave)="mouseLeaveEvent()"
      (contextmenu)="onContextMenu($event, jour)"
  -->
    <div class="cal-frame">
      <table id="table-selectable" class="curr" >
        <tbody>
          <tr *ngFor="let cal of cals.val; ">
            <td class="nil" ><div [ngStyle]="cals.cssWeek.bgColor" ><div [ngStyle]="cals.cssWeek.textColor">{{cal[6].week}}</div></div></td>
            <td *ngFor="let jour of cal "  
              [id]="jour.strDate"
              [ngClass]="jour.actif? 'selectable':''"              
              [class.statut]="jour.statut"  
              [matTooltip]="jour.tooltip"     
              matTooltipClass="material-tooltip">
                <div [ngStyle]="jour['bgColor']" ><div [ngStyle]="jour.textColor" >{{jour.nb}}</div></div>         
            </td>
          </tr>
          <tr *ngFor="let cal of cals.restColonne; ">
            <td class="nil" colspan="8"></td>
          </tr>
        </tbody>
      </table>    
    </div>
  </div>
</div>

